(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/_base/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/_base/pay.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  getProductNumeric
} = svs.numbergames.productMapping;

class PayBase extends svs.tur.payment.base.Pay {
  constructor(_ref) {
    let {
      wagerModel,
      jupiterOptions
    } = _ref;
    if (!(wagerModel || wagerModel instanceof Backbone.Model)) {
      svs.tur.payment.logger.warn('wagerModel is required. Aborting.');
      throw Error('Missing argument wagerModel');
    }
    super();
    this.wagerModel = wagerModel;
    this.jupiterOptions = jupiterOptions;
    this.fetchUrls = [];
    this.drawData = [];
    this.roomKeys = [];
    this.productId = [];
  }
  onAccountStatusSuccess() {
    if (this.fetchUrls.length) {
      this.fetchNeededPayableData();
    } else {
      this.showConfirmDialog();
    }
  }
  onAccountStatusFailed() {
    this.destroy();
  }
  fetchNeededPayableData() {
    const multiFetcher = new svs.tur.payment.services.Multifetcher({
      urls: this.fetchUrls
    });
    multiFetcher.fetch().done(_ref2 => {
      let {
        responseMap
      } = _ref2;
      return this.onFetcherSuccess({
        responseMap
      });
    }).fail(error => {
      svs.tur.apierrors.showErrorMessage({
        response: error
      });
      const errorMsg = "multiFetcher Error! ".concat(error);
      svs.tur.payment.logger.error(errorMsg);
      throw Error(errorMsg);
    });
  }
  onFetcherSuccess(_ref3) {
    let {
      responseMap
    } = _ref3;
    this.mapFetcherResponse({
      responseMap
    });
    this.showConfirmDialog();
  }
  mapFetcherResponse(_ref4) {
    let {
      responseMap
    } = _ref4;
    responseMap.forEach((value, key) => {
      if (/draws/.test(key)) {
        var _this$drawData, _this$drawData2;
        if (value !== null && value !== void 0 && value.draw) {
          this.drawData.push(value.draw.currentDraw);
        } else if (value !== null && value !== void 0 && value.draws) {
          const {
            currentDraw,
            currentDraws
          } = value.draws;
          if (currentDraw) {
            this.drawData.push(currentDraw);
          } else if (currentDraws) {
            currentDraws.forEach(d => this.drawData.push(d));
          }
        }
        if (!this.drawData.length) {
          return;
        }
        this.productId.push((_this$drawData = this.drawData[this.drawData.length - 1]) === null || _this$drawData === void 0 ? void 0 : _this$drawData.productId);
        this.roomKeys.push((_this$drawData2 = this.drawData[this.drawData.length - 1]) === null || _this$drawData2 === void 0 ? void 0 : _this$drawData2.roomKeys);
      } else if (/packages/.test(key)) {
        this.addPackageIdToPayableObj({
          packages: value.packages
        });
      }
    });
  }
  addPackageIdToPayableObj(_ref5) {
    let {
      packages,
      payableObj = this.payableObj
    } = _ref5;
    const packageNameShort = this.wagerModel.get('packageNameShort');
    packages.forEach(packageObj => {
      if (packageObj.name.indexOf(packageNameShort) > -1) {
        payableObj.bagType = packageObj.id;
      }
    });
  }
  getConfirmDialogProps() {
    return {
      productName: this.productName,
      price: this.price,
      accountBalance: this.account.balance
    };
  }
  sendPayment() {
    var _this$payableObj;
    if (this.paymentCallInProgress) {
      svs.tur.payment.logger.info('Jupiter call already in progress, blocking');
      return;
    }
    if ((_this$payableObj = this.payableObj) !== null && _this$payableObj !== void 0 && _this$payableObj.bets || Array.isArray(this.payableObj)) {
      const betArray = [];
      if (Array.isArray(this.payableObj)) {
        betArray.push(...this.payableObj.flatMap(o => o.bets));
      } else {
        betArray.push(...this.payableObj.bets);
      }
      betArray.forEach(bet => {
        var _this$drawData3;
        if (bet.drawNum === undefined && (_this$drawData3 = this.drawData) !== null && _this$drawData3 !== void 0 && _this$drawData3.length) {
          const numericId = getProductNumeric(bet.productId);
          const draw = this.drawData.find(d => d.productId === numericId);
          if (draw !== null && draw !== void 0 && draw.drawNumber) {
            svs.tur.payment.logger.info("drawNum was missing in bet for ".concat(bet.productId, ". Adding ").concat(draw.drawNumber));
            bet.drawNum = draw.drawNumber;
          }
        }
      });
    }
    this.jupiterCaller = new svs.tur.payment.api.jupiter.Jupiter({
      data: this.payableObj,
      jupiterOptions: this.jupiterOptions,
      onSuccess: _ref6 => {
        let {
          response
        } = _ref6;
        return this.onPaymentSuccess({
          response
        });
      },
      onError: (xhr, textStatus, errorThrown) => this.onPaymentError({
        xhr,
        textStatus,
        errorThrown
      })
    });
    this.jupiterCaller.call();
    this.paymentCallInProgress = true;
  }
  onPaymentSuccess(_ref7) {
    let {
      response
    } = _ref7;
    const {
      PAYMENT_SUCCESS
    } = svs.tur.payment.constants.events;
    let paymentFailed = false;
    const handleMultiWagersError = tpError => {
      paymentFailed = true;
      const {
        facility,
        errCode,
        details,
        errDesc
      } = tpError;
      const code = "".concat(facility, " ").concat(errCode);
      this.onPaymentError({
        xhr: {
          responseText: JSON.stringify({
            error: {
              code,
              message: errDesc
            }
          })
        },
        textStatus: details,
        errorThrown: errDesc
      });
    };
    if (this.jupiterCaller.isOwnRows(this.payableObj)) {
      if (Array.isArray(response.regWagerResults)) {
        const failedWager = response.regWagerResults.find(wagerResponse => Boolean(wagerResponse.tpError));
        if (failedWager) {
          handleMultiWagersError(failedWager.tpError);
        }
      }
    } else if (this.isMultiplePayableObjs()) {
      response.regWagerResults.forEach((wagerResponse, index) => {
        if (wagerResponse.tpError) {
          handleMultiWagersError(wagerResponse.tpError);
        } else if (wagerResponse.regWagerResult) {
          this.sendAnalytics({
            wagerId: this.getWagerIdFromApiResponse(wagerResponse.regWagerResult),
            betsObj: this.payableObj[index].bets,
            isSyndicate: Boolean(this.syndicate)
          });
        }
      });
    } else {
      this.sendAnalytics(_objectSpread(_objectSpread({
        wagerId: this.getWagerIdFromApiResponse(response),
        betsObj: this.payableObj.bets
      }, response), {}, {
        isSyndicate: Boolean(this.syndicate)
      }));
    }
    if (!paymentFailed) {
      svs.tur.payment.logger.debug(PAYMENT_SUCCESS);
      this.trigger(PAYMENT_SUCCESS, response);
      this.showSuccessDialog();
    }
  }
  onPaymentError(_ref8) {
    let {
      xhr,
      textStatus,
      errorThrown
    } = _ref8;
    svs.tur.payment.logger.warn("failure (".concat(JSON.stringify(xhr), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));
    this.paymentErrorHandler = new svs.tur.payment.services.PaymentError({
      xhr
    });
    const {
      PAYMENT_ERROR
    } = svs.tur.payment.constants.events;
    const {
      errorType
    } = this.paymentErrorHandler.getErrorData();
    const detailedEvent = "".concat(PAYMENT_ERROR, ":").concat(errorType);
    this.trigger(PAYMENT_ERROR, {
      errorType
    });
    this.trigger(detailedEvent, {
      xhr
    });

    if (Object.keys(this.callbacks).indexOf(detailedEvent) === -1) {
      this.paymentErrorHandler.showErrorDialog();
    } else {
      svs.tur.payment.logger.info("Custom listener found for \"".concat(detailedEvent, "\". Preventing default!"));
    }
    this.destroy();
  }
  showSuccessDialog() {
    new svs.tur.payment.dialogs.PaymentSuccess({
      isSyndicate: this.isSyndicate(),
      onConfirm: () => {
        this.onSuccessDialogConfirm();
      }
    });
  }
  onSuccessDialogConfirm() {
    const {
      DIALOG_SUCCESS_CONFIRM
    } = svs.tur.payment.constants.events;
    svs.tur.payment.logger.debug(DIALOG_SUCCESS_CONFIRM);
    this.trigger(DIALOG_SUCCESS_CONFIRM, {});
    this.destroy();
  }
  onErrorDialogConfirm() {
    const {
      DIALOG_ERROR_CONFIRM
    } = svs.tur.payment.constants.events;
    svs.tur.payment.logger.debug(DIALOG_ERROR_CONFIRM);
    this.trigger(DIALOG_ERROR_CONFIRM, {});
    this.destroy();
  }

  sendAnalytics(_ref9) {
    let {
      wagerId,
      betsObj
    } = _ref9;
    new svs.tur.payment.services.Analytics({
      betsObj,
      wagerId,
      wagerModel: this.wagerModel,
      isSyndicate: this.isSyndicate()
    });
  }
  isMultiplePayableObjs() {
    return Array.isArray(this.payableObj);
  }
  getWagerIdFromApiResponse(response) {
    return response.wagerClientSerial;
  }
}
svs.tur.payment.api.jupiter.base.PayBase = PayBase;

 })(window);